import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useBlogViews = (slug) => {
  const [views, setViews] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const trackView = async () => {
      if (!slug) return;
      
      try {
        // Increment view count on page load
        const response = await fetch(`${API_URL}/api/blog/views/${slug}`, {
          method: 'POST'
        });
        
        if (response.ok) {
          const data = await response.json();
          setViews(data.views);
        }
      } catch (error) {
        console.error('Error tracking view:', error);
      } finally {
        setLoading(false);
      }
    };

    trackView();
  }, [slug]);

  // Format view count for display
  const formatViews = (viewCount) => {
    if (!viewCount) return '600+';
    if (viewCount >= 1000) {
      return `${(viewCount / 1000).toFixed(1)}K`;
    }
    return viewCount.toString();
  };

  return {
    views,
    formattedViews: formatViews(views),
    loading
  };
};

export default useBlogViews;
